export default __webpack_public_path__ + "static/media/cybersoc.2dc08218.png";